import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

const useNavigationStore = create(
    devtools(
        persist((set) => ({
            isSideBarOpen: false,
            isChatSidebarOpen: false,
            expandedSideBarOption: '',
            setIsSideBarOpen: (value) => set((state) => ({ ...state, isSideBarOpen: value })),
            setIsChatSidebarOpen: (value) => set((state) => ({ ...state, isChatSidebarOpen: value })),
            setExpandedSideBarOption: (to) => set((state) => ({ ...state, expandedSideBarOption: to })),
        }), {
            name: 'navigation-storage'
        }
        )
    )
)

export {
    useNavigationStore
}